import { render, staticRenderFns } from "./ProgramPreview.vue?vue&type=template&id=6619d2de&"
import script from "./ProgramPreview.vue?vue&type=script&lang=js&"
export * from "./ProgramPreview.vue?vue&type=script&lang=js&"
import style0 from "./ProgramPreview.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ProgramPreview.vue"
export default component.exports